
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateCalculationitemsGroupDtoFormGroup() {
return new FormGroup({
    calculationId: new FormControl<number | undefined>(undefined, [Validators.required]),
    name: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    sortableRank: new FormControl<number | undefined>(undefined),
})
;
}
      